import axios from 'axios';

// Default to proxied API path for local dev; allow override via env.
const baseURL = process.env.VUE_APP_BASE_URL_API || '/api';

const api = axios.create({
	baseURL,
	headers: {
		'Content-Type': 'application/json'
	},
	timeout: 60000
});

api.interceptors.request.use(
	config => {
		const user = JSON.parse(localStorage.getItem('user'));
		if (user) {
			config.headers.common['x-auth-token'] = user.token;
		}
		return config;
	},
	error => {
		return Promise.reject(error);
	}
);

api.interceptors.response.use(
	response => {
		if (response.status === 200 || response.status === 201) {
			return Promise.resolve(response);
		} else {
			return Promise.reject(response);
		}
	},
	error => {
		return Promise.reject(error.response);
	}
);

export default api;